import { ChangeEvent } from 'react';
import {
  Checkbox, FormControlLabel, Radio, RadioGroup, TextField,
} from '@mui/material';
import { ApplicationQuestion } from 'lib/types/jobs';
import { RequireStar } from 'elements/RequireStar';

interface Props {
  question: ApplicationQuestion;
  answer: string;
  error?: boolean;
  onChange: (questionId: number, answer: string) => void;
}

export const CustomAnswer = ({
  question, answer, error, onChange,
}: Props) => {
  const change = (e: ChangeEvent<HTMLInputElement>) => {
    if (!question.id) return;

    onChange(question.id, e.target.value);
  };

  const changeMulti = (e: ChangeEvent<HTMLInputElement>, checked: boolean) => {
    if (!question.id) return;

    const answers = answer ? answer.split(',') : [];
    if (checked) {
      onChange(question.id, [...answers, e.target.value].join(','));
    } else {
      onChange(question.id, answers.filter((a) => a !== e.target.value).join(','));
    }
  };

  const getChoices = () => {
    switch (question.type) {
    case 'single-select':
      return (
        <RadioGroup
          aria-labelledby={question.question}
          className="w-full grid grid-cols-2"
          value={answer || ''}
          onChange={change}
        >
          {question.choices?.map((c) => (
            <FormControlLabel
              key={c}
              value={c}
              control={<Radio />}
              label={c}
              checked={answer?.includes(c) || false}
            />
          ))}
        </RadioGroup>
      );
    case 'multi-select':
      return (
        <div className="w-full grid grid-cols-2">
          {question.choices?.map((c) => (
            <FormControlLabel
              key={c}
              control={(
                <Checkbox
                  checked={answer?.includes(c) || false}
                  onChange={changeMulti}
                  value={c}
                />
              )}
              label={c}
            />
          ))}
        </div>
      );
    default:
      return (
        <div className="mt-2">
          <TextField
            fullWidth
            size="small"
            value={answer || ''}
            onChange={change}
          />
        </div>
      );
    }
  };

  return (
    <div className="mb-4">
      <label htmlFor={`${question.question}-${question.id}`} className="font-semibold mb-3">
        <RequireStar />
        {question.question}
      </label>
      <div>
        {getChoices()}
      </div>
      {error && <div className="text-red text-sm">an answer is required</div>}
    </div>
  );
};
